import { render, staticRenderFns } from "./verify-alert.vue?vue&type=template&id=673924e0&scoped=true"
import script from "./verify-alert.vue?vue&type=script&lang=js"
export * from "./verify-alert.vue?vue&type=script&lang=js"
import style0 from "./verify-alert.vue?vue&type=style&index=0&id=673924e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673924e0",
  null
  
)

export default component.exports